import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import AddNoteForm from '../AddNoteForm/AddNoteForm';

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  positionId?: number;
  isNotHirable: boolean;
}
const AddNoteModal: FC<Props> = ({
  isOpen,
  setIsOpen,
  positionId,
  isNotHirable,
}) => {
  const [t] = useTranslation('global');
  return (
    <ModalInTailwind closeModal={() => setIsOpen(false)} isOpen={isOpen}>
      <div data-testid="add-note-modal" className="bg-white px-8 py-4 rounded">
        <h3
          style={{
            color: 'var(--brand-dark-grey)',
          }}
          className="font-semibold text-xl"
        >
          {t('Notes.CreateNote')}
        </h3>
        <AddNoteForm
          setIsOpen={setIsOpen}
          positionId={positionId}
          isNotHirable={isNotHirable}
        />
      </div>
    </ModalInTailwind>
  );
};
AddNoteModal.defaultProps = {
  positionId: 0,
};

export default AddNoteModal;
